import React from "react";
import { Box, Container, Grid, Card, Typography } from "@mui/material";
import {
  CameraAlt as CameraIcon,
  BarChart as BarChartIcon,
  People as PeopleIcon,
  NotificationsActive as AlertsIcon,
} from "@mui/icons-material";

export default function Features() {
  const features = [
    {
      icon: <CameraIcon sx={{ fontSize: 40 }} />,
      title: "Real-time Monitoring",
      description: "Live camera feeds with instant wildlife detection alerts",
      color: "#4CAF50",
    },
    {
      icon: <BarChartIcon sx={{ fontSize: 40 }} />,
      title: "Advanced Analytics",
      description: "Comprehensive statistics for conservation insights",
      color: "#2196F3",
    },
    {
      icon: <PeopleIcon sx={{ fontSize: 40 }} />,
      title: "User Management",
      description: "Hierarchical system with role-based access control",
      color: "#FF9800",
    },
    {
      icon: <AlertsIcon sx={{ fontSize: 40 }} />,
      title: "Instant Alerts",
      description: "Real-time notifications for critical wildlife events",
      color: "#E91E63",
    },
  ];

  return (
    <Box
      sx={{
        py: 8,
        background: "linear-gradient(180deg, #424242 0%, #0d0d0d 100%)",
        position: "relative",
      }}
      id="features"
    >
      <Container maxWidth="xl">
        <Typography
          variant="h3"
          fontWeight={700}
          gutterBottom
          sx={{
            textAlign: "center",
            mb: 2,
            color: "#fff",
            fontSize: { xs: "2rem", md: "3rem" },
          }}
        >
          Platform Features
        </Typography>
        <Typography
          variant="body1"
          sx={{
            textAlign: "center",
            mb: 5,
            color: "rgba(255,255,255,0.7)",
            maxWidth: 600,
            mx: "auto",
          }}
        >
          Cutting-edge technology for wildlife conservation and monitoring
        </Typography>

        <Grid container spacing={3}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card
                sx={{
                  p: 3,
                  height: "100%",
                  borderRadius: 4,
                  transition: "all 0.4s ease",
                  background:
                    "linear-gradient(135deg, rgba(26,26,26,0.95) 0%, rgba(45,45,45,0.95) 100%)",
                  border: "1px solid rgba(255,255,255,0.05)",
                  "&:hover": {
                    transform: "translateY(-12px)",
                    borderColor: feature.color,
                    boxShadow: `0 20px 60px ${feature.color}30`,
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                    color: feature.color,
                  }}
                >
                  {feature.icon}
                </Box>
                <Typography
                  variant="h6"
                  gutterBottom
                  fontWeight={600}
                  textAlign="center"
                  sx={{ color: "#fff" }}
                >
                  {feature.title}
                </Typography>
                <Typography
                  variant="body2"
                  textAlign="center"
                  sx={{ color: "rgba(255,255,255,0.6)" }}
                >
                  {feature.description}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
